// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"3a70429b","787":"39401046","816":"eec6f95b"}[chunkId] + ".chunk.js";
};